import { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { BsEye } from 'react-icons/bs';

const ToogablePasswordField = ({ onChangeEvent, callback }) => {
	const [isPasswrodSeen, setSeePassword] = useState(false);

	return (
		<Form.Group id='password'>
			<Form.Label>Senha</Form.Label>
			<InputGroup>
				<Form.Control
					onKeyDown={(e) => {
						if (e.key == 'Enter') callback();
					}}
					type={isPasswrodSeen ? 'text' : 'password'}
					placeholder='entre com sua senha'
					onChange={(event) => onChangeEvent(event.target.value)}
				/>
				<Button onClick={() => setSeePassword((isSee) => !isSee)}>
					<BsEye />
				</Button>
			</InputGroup>
		</Form.Group>
	);
};

export default ToogablePasswordField;
